export default "__VITE_ASSET__kxE_bIuH__"